// extracted by mini-css-extract-plugin
export default {"page":"Confirm_page__oVAWN","container":"Confirm_container__qIyyK"};